/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
document.querySelectorAll(".open_hero_herre_cstm").forEach(item => {
  item.addEventListener("click",function(event){
    event.preventDefault()
    document.querySelector(".cstm_title_nav").click();
    setTimeout(function(){
      document.querySelector(".cstm_flink_herre").click();
    },500)
  })
});
  
document.querySelectorAll(".open_hero_damm_cstm").forEach(items => {
  items.addEventListener("click",function(event){
    event.preventDefault()
    document.querySelector(".cstm_title_nav").click();
    setTimeout(function(){
      document.querySelector(".cstm_flink_dame").click();
    },500)
  })
});

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();

/* ===== cstm: Mega-menu (to-panel, billeder, hover-åbning) til v8 ===== */
(function () {
  function ready(fn){ if(document.readyState!=='loading'){fn();} else {document.addEventListener('DOMContentLoaded',fn);} }
  ready(function () {
    var mm = document.querySelector('[data-cstm-mm]');
    if (!mm) return;
    var html = document.documentElement;
    var openTimer;

    function openMM(e){ if(e){e.preventDefault();} clearTimeout(openTimer); mm.hidden=false; requestAnimationFrame(function(){ mm.classList.add('is-open'); }); html.classList.add('cstm-mm-lock'); }
    function closeMM(){ mm.classList.remove('is-open','is-showing-sub'); html.classList.remove('cstm-mm-lock'); setTimeout(function(){ mm.hidden=true; }, 350); }

    // Triggers: KUN klik (åbner på klik på "Shop", ikke hover)
    document.querySelectorAll('.cstm_title_nav, [data-cstm-mm-open]').forEach(function(t){
      t.addEventListener('click', openMM);
    });
    // Hamburger (mobil) åbner også vores menu
    var burger = document.querySelector('[data-drawer-toggle="hamburger"]');
    if (burger) { burger.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); openMM(); }, true); }

    // Luk
    mm.querySelectorAll('[data-cstm-mm-close]').forEach(function(b){ b.addEventListener('click', closeMM); });
    document.addEventListener('keydown', function(e){ if(e.key==='Escape' && mm.classList.contains('is-open')) closeMM(); });

    // Vis under-panel (niveau 3) for en kategori
    function activateCat(cat){
      if(!cat) return;
      var id = cat.getAttribute('data-cstm-mm-cat');
      var panel = cat.closest('.cstm-mm__level2');
      if(panel){ panel.querySelectorAll('[data-cstm-mm-cat]').forEach(function(c){ c.classList.toggle('is-active', c===cat); }); }
      mm.querySelectorAll('[data-cstm-mm-sub]').forEach(function(s){ s.classList.toggle('is-active', s.getAttribute('data-cstm-mm-sub')===id); });
      mm.classList.add('is-showing-sub');
    }
    mm.querySelectorAll('[data-cstm-mm-cat]').forEach(function(cat){
      cat.addEventListener('mouseenter', function(){ activateCat(cat); });
      cat.addEventListener('click', function(){ activateCat(cat); });
    });

    // Faner (niveau 1)
    function activateTab(tab){
      var i = tab.getAttribute('data-cstm-mm-tab');
      mm.querySelectorAll('[data-cstm-mm-tab]').forEach(function(t){ t.classList.toggle('is-active', t===tab); });
      mm.querySelectorAll('[data-cstm-mm-panel]').forEach(function(p){ p.classList.toggle('is-active', p.getAttribute('data-cstm-mm-panel')===i); });
      mm.classList.remove('is-showing-sub');
      // auto-vis første kategori i den aktive fane
      var activePanel = mm.querySelector('.cstm-mm__level2[data-cstm-mm-panel="'+i+'"]');
      var firstCat = activePanel ? activePanel.querySelector('[data-cstm-mm-cat]') : null;
      if(firstCat){ activateCat(firstCat); mm.classList.remove('is-showing-sub'); }
    }
    mm.querySelectorAll('[data-cstm-mm-tab]').forEach(function(tab){
      tab.addEventListener('click', function(){ activateTab(tab); });
      tab.addEventListener('mouseenter', function(){ activateTab(tab); });
    });

    // Tilbage (mobil)
    mm.querySelectorAll('[data-cstm-mm-back]').forEach(function(b){
      b.addEventListener('click', function(){ mm.classList.remove('is-showing-sub'); });
    });

  });
})();

/* ===== cstm: Fælles lande-/sprogvælger toggle (top + slider) ===== */
(function () {
  function ready(fn){ if(document.readyState!=='loading'){fn();} else {document.addEventListener('DOMContentLoaded',fn);} }
  ready(function () {
    document.querySelectorAll('[data-cstm-cs-toggle]').forEach(function(btn){
      btn.addEventListener('click', function(e){
        e.preventDefault(); e.stopPropagation();
        var cs = btn.closest('[data-cstm-cs]');
        var open = cs.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
    document.addEventListener('click', function(e){
      document.querySelectorAll('[data-cstm-cs].is-open').forEach(function(cs){
        if(!cs.contains(e.target)) cs.classList.remove('is-open');
      });
    });
  });
})();

/* ===== cstm: Farve-swatches – vis 6 + "+N", udvid ved klik ===== */
(function () {
  function ready(fn){ if(document.readyState!=='loading'){fn();} else {document.addEventListener('DOMContentLoaded',fn);} }
  var LIMIT = 6;
  function apply(row){
    var items = Array.prototype.slice.call(row.querySelectorAll('.cstm_sp')).filter(function(el){ return !el.classList.contains('cstm-colors__more'); });
    var more = row.querySelector('.cstm-colors__more');
    if (items.length <= LIMIT) {
      if (more) more.parentNode.removeChild(more);
      items.forEach(function(i){ i.style.display = ''; });
      return;
    }
    if (row.getAttribute('data-expanded') === '1') {
      items.forEach(function(i){ i.style.display = ''; });
      if (more) more.parentNode.removeChild(more);
      return;
    }
    items.forEach(function(it, idx){ it.style.display = idx < LIMIT ? '' : 'none'; });
    if (!more) {
      more = document.createElement('div');
      more.className = 'cstm_sp cstm-colors__more';
      more.setAttribute('role', 'button');
      more.tabIndex = 0;
      var reveal = function(){ row.setAttribute('data-expanded', '1'); apply(row); };
      more.addEventListener('click', reveal);
      more.addEventListener('keydown', function(e){ if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); reveal(); } });
      items[LIMIT - 1].insertAdjacentElement('afterend', more);
    }
    more.textContent = '+' + (items.length - LIMIT);
  }
  function run(){ document.querySelectorAll('.cstm-colors .cstm_product').forEach(apply); }
  ready(function(){
    run();
    // Kør igen når farverne hentes asynkront (Storefront API)
    var host = document.querySelector('.cstm-colors');
    if (host && window.MutationObserver) {
      var obs = new MutationObserver(function(){ run(); });
      host.querySelectorAll('.cstm_product').forEach(function(c){ obs.observe(c, { childList: true }); });
    }
  });
})();
